import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import customPricingReducer from './reducers/index';
import { watchCustomPricingActions } from './sagas/index';

const sagaMiddleware = createSagaMiddleware();

// Root reducer
const rootReducer = combineReducers({
  customPricing: customPricingReducer,
});

// Combine middleware and dev tools into a single enhancer
const composeEnhancers = 
  (window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'])
    ? window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__']({})
    : compose;

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(sagaMiddleware))  // Combine middleware and devtools here
);

sagaMiddleware.run(watchCustomPricingActions);

export default store;
